import { ReactNode } from 'react';

type Props = {
  readonly children: ReactNode;
};

// 언어 관리는 _app.tsx에서 처리합니다
export default function LanguageManager({ children }: Props) {
  return <>{children}</>;
}
